



import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { addAiChatTitle, addChatSubTitleWithQuestion, addNewQuestionLocal, deleteAIChatSubTitle, deleteChatTitle } from "../../../features/aiControl/aiControlSlice"
import AIQuestionItemAdd from "../../aiControl/AIQuestionItemAdd"
import InputNewSubTitle from "../../shared/input/ai/InputNewSubTitle"
import InputText from "../../shared/input/new/InputText"
import PageTopTitle from "../../shared/PageTopTitle"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            padding: 40px;
            padding-top: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 50px;

            p{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                line-height: 1.4;
                text-align: center;

                span{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                    color: var(--color-main);
                }
            }

            .btn-container{
                display: flex;
                gap: 40px;
            }

        }
    }
`
const DeleteAiChatTitlePermissionModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const {aiTitleData} = useSelector(state => state.aiControl)

    const { lockScroll, unlockScroll } = useScrollLock();


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleClick = () => {

        if(aiTitleData.isTitle){
            dispatch(deleteChatTitle(aiTitleData.id)); 
        }
        else{
            dispatch(deleteAIChatSubTitle(aiTitleData.id))
        }

    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <div className="content">
            <p><span>{aiTitleData.name}</span> isimli sohbet {!aiTitleData.isTitle && "alt"} başlığını silmek istediğinize emin misiniz, eğer bu {!aiTitleData.isTitle && "alt"} başlığı silerseniz bu {!aiTitleData.isTitle ? "alt başlığa ait girdiler" : "başlığa ait alt başlıklar ve girdiler"} de silinecektir</p>
            <div className="btn-container">
                <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width="160px" handleClick={handleClick}>Sil</Btn>
                <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width="160px" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </div>
</ModalContainer>
  )
}

export default DeleteAiChatTitlePermissionModal